
import axios from '../../definitions/axios';

export const getAllBlog = () => {
  return axios.get(`/blog/post/` );
};
export const getAllBlogs= (params) => {
  return axios.get(`/blog/post/`, { params: params} );
};
export const getMainBlog = () => {
  return axios.get(`/blog/post_on_main/` );
};
export const getCategories = () => {
  return axios.get(`/blog/category/`);
};